import React, {useState,useEffect,Suspense} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { Loading,CardPerso,CreatePersonalizedPriceForm,EditModalActionButton,DeleteActionButton,ColumDataTableReorganize,useLocalStorage,articleColumnGenerate,customFieldsColumnGenerate,priceSuppColumnGenerate,enumereColumnGenerate,articleEditionDatatable,articleDataGenerator,CarouselImage,articlePriceUnitSuppDataGenerator, ExportArticleButton,AddMarkExportForm } from "@gull";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, ColumnToggle  } from "react-bootstrap-table2-toolkit";
import axios from 'axios'
import { useCookies} from 'react-cookie';
import swal from "sweetalert2"
import { Modal } from "react-bootstrap";
import { allPersonalizedPrice,personalizedPricePrefixe } from 'app/allPersonalizedPrice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Moment from 'react-moment';
import {scrollXDataTable} from 'app/scrollXDataTable';
import {articleListErp} from 'app/columnsArticleListeDataTable'

const useLoad = (props) => {
    const t = useTranslate();
    const [personalizedPrices,setPersonalizedPrices]=useState([])
    const [error,setError]=useState(false)
    const [loading,setLoading]=useState(false)
    const [paramUrlPersonalizedPrice,setParamUrlPersonalizedPrice]=useState((props.type) ? `${props.type}/1` : 'all/1')

    const buildFiltre = (props, filterCompany) => {
        const obj = {};

        if (props.clientId) obj.client = props.clientId;

        if (filterCompany !== '') {
            if (filterCompany === props.company.id + '-company') obj.company = props.company.id;
            else obj.other_company = filterCompany;
        }

        obj.type = props.type;
        return obj;
    };
    const [filtre,setFiltre] = useState(() => buildFiltre(props, props.filterCompany ?? ''))

    const [sizeDatas,setSizeDatas]=useState(0)
    
    useEffect(function () {
        (async function() {
            setLoading(prev=>true)
            const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/personalized_price/type/"+paramUrlPersonalizedPrice, filtre
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    setError(messageError)
                }
                else{
                    setSizeDatas(response.data.count)
                    setPersonalizedPrices(response.data.datas)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setLoading(prev=>false)
        })()
    }, [props.reloadPersonalizedPrice])
    
    return [personalizedPrices,setPersonalizedPrices,error,loading,setLoading,setParamUrlPersonalizedPrice,filtre,setFiltre,sizeDatas]
} 

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columnShow.length)
    }, [window.screen.width,props.columnShow.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            pagination={paginationFactory(props.paginationOptions)}
            noDataIndication={t('tableNoData')}
            rowStyle={ props.rowStyle }
            defaultSortDirection={props.defaultSortDirection}
            hover
            condensed
            responsive
        />
    );
};

const PersonalizedPriceList = (props) => {
    const t = useTranslate();
    let { SearchBar } = Search;

    const [personalizedPrices,setPersonalizedPrices,error,loading,setLoading,setParamUrlPersonalizedPrice,filtre,setFiltre,sizeDatas]=useLoad(props)
    
    const [showCreate,setShowCreate]=useState(false)
    const [currentPromo,setCurrentPromo]=useState(props.type ? props.type : 'all')
    const [modalEditId,setModalEditId]=useState(false)
    const [filterActivePromo,setFilterActivePromo]=useState(1)
    const [filterCompany,setFilterCompany]=useState('')
    const [perPage,setPerPage]=useState(50)

    const [localStorage, setLocalStorage] = useLocalStorage(['personalized_price_list_fields','personalized_price_list_reorganize']);

    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 

    //Pour le carousel
    const [showCarousel,setShowCarousel]=useState(false) 
    const [modalItemName,setModalItemName]=useState('') 
    const [modalImage,setModalImage]=useState('') 

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    let cookieLecture = ['type','promotion','end','otherCompany','state','internalid','name','reference','price','action'];
    if(localStorage.personalized_price_list_fields){
        let columnShowVar = localStorage.personalized_price_list_fields;
        cookieLecture = columnShowVar.split(',')
    }
    const [columnShow,setColumnShow] = useState(cookieLecture)

    //partie qui concerne l'export et permet d'exporter le tableau dans l'ordre dans lequel il est affiché 
    const [lang, setLang] = useCookies(['lang']);
    const [headerColumnShowExport,setHeaderColumnShowExport]=useState('') 
    const [addMark,setAddMark]=useState(true) 

    useEffect(function () {
        let headerColumnShowExportArr = [] 
        
        columnOrganize.map(value=>{
            if(columnShow.includes(value.dataField)) headerColumnShowExportArr.push(value.dataField)
        })
        setHeaderColumnShowExport(headerColumnShowExportArr.join(',').replace('action,',''))
    }, [columnShow,columnOrganize])

    let headerAllExport = (localStorage.personalized_price_list_reorganize) ? localStorage.personalized_price_list_reorganize.replace('action,masque,','') : 'all'
    //End
    

    useEffect(function () {
        let obj = {}

        if(props.clientId) obj['client']=props.clientId
        if(filterCompany!=''){ 
            if(filterCompany==props.company.id+'-company'){
                obj['company']=props.company.id
            }else{
                obj['other_company']=filterCompany
            }
        }
        obj['type'] = props.type

        setFiltre(obj)

    }, [filterCompany,props.clientId])

    const deletePersonalizedPrice = async (promoId) => {
        const response  = await axios.delete(process.env.REACT_APP_API_URL+"api/erp/personalized_price/delete/"+promoId
        ).then((response) => {
            let updateList = personalizedPrices.filter(value=>value.id!=promoId)
            setPersonalizedPrices(updateList)
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    const openModalCarousel = (image,itemName) =>{
        setModalImage(image)
        setModalItemName(itemName)
        setShowCarousel(true)
    }

    const closeModalCarousel = () =>{
        setModalImage('')
        setModalItemName('')
        setShowCarousel(false)
    }

    let datas = new Array
    personalizedPrices.forEach((value,ind)=>{
        let percentPromo = value.type.includes('percent')
        let percentPrixfixe = value.type.includes('prixfixe')
        let promo
        let companyList = ''

        if(personalizedPricePrefixe.includes(value.type)){
            if(percentPromo){
                if(value.value.length>1){
                    let promoStr = ''
                    value.value.map(promoAmount=>{
                        promoStr += '-'+promoAmount+'% '
                    })
                    promo = promoStr
                }else{
                    promo = '-'+value.value+'%'
                }
            }else if (percentPrixfixe) { 
                promo = value.value
            }
            else {
                promo = '-'+value.value
            }
        }else{
            promo = value.value
        }

        if(value.company.length!=0) companyList=value.company[0].code

        for(var i=0; i<value.other_company.length; i++){
            if(companyList==''){
                companyList += value.other_company[i].code
            }else{
                companyList += ', '+value.other_company[i].code
            }
        }

        let article = value.article

        let obj = {
            masque:'',
            type: t(value.type),
            promotion: promo,
            end: value.end != null ? <Moment format="DD/MM/YYYY">{value.end}</Moment> : t('undefined'),
            id: value.id,
            state: (value.status==0) ? t('finished') : (value.status==1) ? t('currentPersonalizedPrice') : t('upcomingPersonalizedPrice'),
            otherCompany: companyList,
            devise:(article.devise_achat!=null) ? article.devise_achat : '',
            action: 
                <span className="d-flex justify-content-between">
                    <EditModalActionButton hisId={value.id} setShowEdit={setShowCreate} setModalEditId={setModalEditId}/>
                    <DeleteActionButton deleteFunctionArgument={value.id} actionType={'typeDeleteX'} nameType={'delete'} toDelete={`${t('personalized_price_delete')} ${value.article.name}`} customClickEvent={deletePersonalizedPrice}/>
                </span>,
            index:ind
        }

        articleDataGenerator(obj,article,t,openModalCarousel)
        articlePriceUnitSuppDataGenerator(obj,article,props.suppPrice)
        props.customFields.forEach((item,index)=>{
            if(article.custom_fields){
                obj[item.name]=article.custom_fields[item.name]
            }
        })

        for (let i=0; i<props.maxConditionnement; i++){
            let numeroEnumere = i+1
            obj['name_'+numeroEnumere]= (article.hasOwnProperty('name_'+numeroEnumere) && article['name_'+numeroEnumere]!=null) ? article['name_'+numeroEnumere] : ''
            obj['reference_'+numeroEnumere]= (article.hasOwnProperty('reference_'+numeroEnumere) && article['reference_'+numeroEnumere]!=null) ? article['reference_'+numeroEnumere] : ''
            obj['quantity_'+numeroEnumere]= (article.hasOwnProperty('quantity_'+numeroEnumere) && article['quantity_'+numeroEnumere]!=null) ? article['quantity_'+numeroEnumere] : ''
        }

        props.suppPrice.map((item,index)=>{
            let numero = index+1
            let margePrixSupp = (article.hasOwnProperty('margeN_'+item['designation_'+numero]) && article['margeN_'+item['designation_'+numero]]!=null && article['margeN_'+item['designation_'+numero]]!=0) ? article['margeN_'+item['designation_'+numero]] : 0

            let margePercentPrixSupp = (article.hasOwnProperty('margeP_'+item['designation_'+numero]) && article['margeP_'+item['designation_'+numero]]!=null && article['margeP_'+item['designation_'+numero]]!=0) ? article['margeP_'+item['designation_'+numero]] : 0


            obj['price_'+item['designation_'+numero]]= (article.hasOwnProperty('price_'+item['designation_'+numero]) && article['price_'+item['designation_'+numero]]!==null && article['price_'+item['designation_'+numero]]!=='') ? article['price_'+item['designation_'+numero]] : ''

            obj['price_'+item['designation_'+numero]+'_ttc']= (article.hasOwnProperty('price_'+item['designation_'+numero]+'_ttc') && article['price_'+item['designation_'+numero]+'_ttc']!==null && article['price_'+item['designation_'+numero]+'_ttc']!=='') ? article['price_'+item['designation_'+numero]+'_ttc'] : ''

            obj['margeN_'+item['designation_'+numero]]= margePrixSupp

            obj['margeP_'+item['designation_'+numero]]= margePercentPrixSupp
        })

        datas.push(obj)
    })

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
                setPerPage(page)
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: datas.length
    };

    const headerSortingStyle = { backgroundColor: '#c8e6c9' };

    let columnsInit = [
        {
            dataField: "action",
            text: 'Actions',
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
        },
        {
            dataField: "type",
            text: 'Type',
            editable: false,
            hidden: (columnShow.includes("type")) ? false : true,
            sort: true,
            headerSortingStyle
        },
        {
            dataField: "promotion",
            text: t('personalized_price'),
            editable: false,
            hidden: (columnShow.includes("promotion")) ? false : true,
            sort: true,
            headerSortingStyle
        },
        {
            dataField: "end",
            text: t('endPersonalizedPrice'),
            editable: false,
            hidden: (columnShow.includes("end")) ? false : true,
            sort: true,
            headerSortingStyle
        },
        {
            dataField: "otherCompany",
            text: t('company'),
            editable: false,
            hidden: (columnShow.includes("otherCompany")) ? false : true,
            sort: false,
            headerSortingStyle
        },
        {
            dataField: "state",
            text: t('statePersonalizedPrice'),
            editable: false,
            hidden: (columnShow.includes("state")) ? false : true,
            sort: true,
            headerSortingStyle
        },
        {
            dataField: "internalid",
            text: t('internalId'),
            editable: false,
            hidden: (columnShow.includes("internalid")) ? false : true,
            sort: true,
            headerSortingStyle,
        },
    ];

    let columns=[
        ...columnsInit,
        ...articleColumnGenerate(articleListErp,columnShow,headerSortingStyle,articleEditionDatatable,props.optionsDataTable,props.ourOptionsDataTable,t,props.authParam),
        ...enumereColumnGenerate(props.maxConditionnement,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam),
        ...priceSuppColumnGenerate(props.suppPrice,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam),
        ...customFieldsColumnGenerate(props.customFields,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam)
    ]

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.personalized_price_list_reorganize){
            let cookieLecture = localStorage.personalized_price_list_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{//on boucle sur toutes les colonnes existante sur le cookie de réorganisation 
                columns.map(item=>{//on vérifie dans l'array columns si les colonnes qu'il contient sont présent dans le cookie 
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle colonne à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    arrCol.push(item);
                }
            })
            columnCookie = arrCol

            if(arrCol.length !== cookieLecture.length){ 
                //Si des données articles ont été ajoutées ou si une configuration d'access à été faite pour rajouter ou retirer des colonnes, le cookie de réorganisation sera mis à jour 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("personalized_price_list_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [props.optionsDataTable,props.ourOptionsDataTable])

    useEffect(function () {
        if(localStorage.personalized_price_list_fields){
            let cookieColumnShow = localStorage.personalized_price_list_fields.split(',')
            let columnsDatas = [] //contient toutes les dataFields de columns
            let arrColumnShow = [] //contient toutes les données sans doublons
            let arrColumnShowDoublon = [] //contient les doublons
            let arrColumnShowIntrus = [] // continent les fausse données

            columns.map(item=>{
                columnsDatas.push(item.dataField)
            })

            cookieColumnShow.map(value=>{
                //on vérifie si le cookie contien des doublons
                if(!arrColumnShow.includes(value)){
                    arrColumnShow.push(value)
                }else{
                    //Si value existe dejà c'est qu'il y a un doublon 
                    arrColumnShowDoublon.push(value)
                }
                //on vérifie si les données du cookies sont des données qui exisent dans le tableau columns
                if(!columnsDatas.includes(value)) arrColumnShowIntrus.push(value)
                
            })

            if(arrColumnShowDoublon.length!=0 || arrColumnShowIntrus.length!=0){ 
                //Si le cookie contient des doublons et des données qui n'existe pas en meme temps
                let uniformData = arrColumnShow.filter(value=> !arrColumnShowIntrus.includes(value))

                setLocalStorage("personalized_price_list_fields",uniformData.join(),{ path: "/", expires: expire_date })
            }
        }
    }, [])

    const handleToggleColumns = (column,indexToEdit) => {
        if(column.toggle){
            var newColumnShow = columnShow.filter(value=>value!=column.dataField)

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = true

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
            
        }
        else{
            var newColumnShow = [...columnShow,column.dataField]

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = false

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
        }
        setLocalStorage("personalized_price_list_fields",newColumnShow.join(),{ path: "/", expires: expire_date }) 
    }

    const rowStyle = (row, rowIndex) => { 
        const style = {};

        if (row.state == t('finished')) {
          style.backgroundColor = '#ffffff';

        }else if(row.state == t('currentPersonalizedPrice')){ 
          style.backgroundColor = '#d9fcd2';

        }else{
            style.backgroundColor = '#ffffbb';
        }
        
        return style;
    };

    const handleLoadData = async (e,name) =>{
        switch (name) {
            case 'active':
                setFilterActivePromo(e.target.value);
                break;
            case 'company':
                setFilterCompany(e.target.value)
                break;
        }
    }

    const submit = () =>{
        setParamUrlPersonalizedPrice(currentPromo+"/"+filterActivePromo)
        if (props.setReloadPersonalizedPrice) props.setReloadPersonalizedPrice(Date.now())
    }

    const closeModal = () =>{
        setShowCreate(false)
        setModalEditId(false)
    }

    let modalTitle = modalEditId ? t('editPersonalizedPrice') : t('createPersonalizedPrice')
    
    return (<>
        <Modal show={showCarousel} onHide={()=>closeModalCarousel()}>
            <Modal.Header closeButton>
                <Modal.Title>{modalItemName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {showCarousel ?
                    <Suspense fallback={<Loading></Loading>}>
                        <CarouselImage images={modalImage} />
                    </Suspense>
                :
                    false
                }
            </Modal.Body>
        </Modal>
        <Modal show={showCreate} onHide={() => closeModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CreatePersonalizedPriceForm 
                    allPersonalizedPrice={allPersonalizedPrice} 
                    closeModal={closeModal}
                    setPersonalizedPrices={setPersonalizedPrices}
                    personalizedPrices={personalizedPrices}
                    currentPromo={currentPromo}
                    modalEditId={modalEditId}
                    company={props.company}
                    from='promolist'
                    clientId={props.clientId}
                    type={props.type}
                    setRelance={props.setReloadPersonalizedPrice}
                />
            </Modal.Body>
        </Modal>
        <CardPerso header={t('personalized_price')}>
            <small>
                <ToolkitProvider
                    keyField="index"
                    data={datas}
                    columns={columnOrganize}
                    columnToggle
                    search
                >
                {(propst) => (
                    <>
                        <div className="row mb-3">
                            <div className="col-3 col-xl-2">
                                <ColumDataTableReorganize 
                                    columnOrganize={columnOrganize}
                                    setColumnOrganize={setColumnOrganize}
                                    setCookie={setLocalStorage}
                                    cookieName='personalized_price_list_reorganize'
                                    { ...propst.columnToggleProps } 
                                    executWhenToggle={handleToggleColumns}
                                    showColumnOrganize={showColumnOrganize}
                                    setShowColumnOrganize={setShowColumnOrganize}
                                    btnSwitch={true}//pour affiche ou non le btn swith
                                    initSwith={false}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                />&nbsp;&nbsp;
                                <button className="btn btn-success btn-sm" onClick={()=>setShowCreate(true)}><FontAwesomeIcon icon={faPlus} /></button>&nbsp;&nbsp;
                                <button disabled={loading} className="btn btn-sm btn-primary" style={{float:'right'}} onClick={()=>submit()}>
                                    {t('btnValidate')}
                                </button>
                            </div>
                            <div className="col-3">
                                <label htmlFor="select a state">{t('statePersonalizedPrice')}</label>
                                <select  className="form-control" type="text" onChange={(e)=>handleLoadData(e,'active')}>
                                    <option value="1">{t('currentAndUpcomingPersonalizedPrice')}</option>
                                    <option value="0">{t('allPersonalizedPrice')}</option>
                                </select>
                            </div>
                            <div className="col-3">
                                <label htmlFor="select a shop">{t('companyOrOtherCompany')}</label>
                                <select  className="form-control" type="text" onChange={(e)=>handleLoadData(e,'company')}>
                                    <option value="">-- Select --</option>
                                    <option value={props.company.id+'-company'}>{props.company.name}</option>
                                    {(Object.keys(props.company).length!=0 && props.company.other_company.length!=0) && props.company.other_company.map((otherCompany)=>{
                                        return(<option key={otherCompany.id} value={otherCompany.id}>{otherCompany.name}</option>)
                                    })}
                                </select>
                            </div>
                            <div className="col-3">
                                <div className="d-flex align-items-baseline">
                                    <ExportArticleButton sizeDatas={sizeDatas} filtre={filtre} addMark={addMark} lang={lang.lang} header={headerAllExport} title={t('downloadCSVAll')} type="button" url={"api/erp/personalized_price/csvitem_personalized_price"}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                    <AddMarkExportForm setAddMark={setAddMark} addMark={addMark} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </div>
                            </div>
                        </div>

                        {(loading || columnOrganize.length==0) ? 
                            <div className='text-center'>
                                <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> 
                            </div>
                        :
                            <>
                                {(error) ? <div className="alert alert-danger mt-3" dangerouslySetInnerHTML={{ __html: error }}></div> : false}
                                <div className="d-flex justify-content-end align-items-center">
                                    <span className="mb-2 me-1">{t('tableSearch')}:</span>
                                    <SearchBar {...propst.searchProps} className="mb-2" />
                                </div>
                                <div className="position-relative">
                                    <CustomDataTable 
                                        propst={propst}
                                        paginationOptions={paginationOptions}
                                        rowStyle={rowStyle}
                                        columnShow={columnShow}
                                        defaultSortDirection="asc"
                                    />
                                </div>
                            </>
                        }
                    </>
                )}
                </ToolkitProvider>
            </small>
        </CardPerso>
        </>
    );
}

export default PersonalizedPriceList;
